<template>
  <router-link
    :to="lang ? '/' + lang + '/cart' : '/cart'"
    class="seasidetms_header_cart_link"
  >
    <span class="count_wrap seasidetms_icon_custom_cart_1">
      <span class="count seasidetms_dynamic_cart_count">{{ cart.qty }}</span>
    </span>
  </router-link>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'MiniCartMobile',
  computed: mapState(['cart']),
  data() {
    return {
      lang: '',
    }
  },
  beforeMount() {
    this.lang = this.$store.getters.lang
  },
  updated() {
    this.lang = this.$store.getters.lang
  },
}
</script>

<style></style>
